var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiffPadding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 77755"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24085",
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 10,
    fill: "white",
    stroke: "#606060"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24095",
    x: 9,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24096",
    x: 9,
    y: 9,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24097",
    y: 9,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24098",
    width: 2,
    height: 2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiffPadding);
export default __webpack_public_path__ + "static/media/diffPadding.4e6085b3bc3a154a663f634812a8e21e.svg";
export { ForwardRef as ReactComponent };